import React from 'react';
import _ from 'lodash';
import {
  ROLE_MAP,
  PERMISSIONS_MAP,
  ROLE_TO_ROLES_MAP,
  ROLE_TO_ROLES_MAP_v2,
  PERMISSIONS_MAP_V2,
} from './constants';
import {Message} from 'semantic-ui-react';
import {ENTITY_MAP} from 'app-ui-componentlibrary/dist/common/constants';

export function validateCells(rows) {
  return _.every(rows, (vals) => {
    if (!_.isObject(vals)) {
      return false;
    } else if (_.some(vals, _.isEmpty)) {
      return false;
    } else {
      return true;
    }
  });
}

export const mapValuesToBody = (values, selectedOrgId) => {
  const mapToCorrectFormat = (role) => {
    let rolesNotAllowed = ['ORGPGMMEMBER', 'ORGFINMEMBER', 'ORGGRNTWRITER', 'ORGMEMBER'];
    if (role.code && role.code != '') {
      let entityTypeId = ENTITY_MAP.ORGANIZATION.code;
      if (role.programs && role.programs.length) {
        entityTypeId = ENTITY_MAP.PROGRAM_ORGANIZATION.code;
        if (
          role.parentOrgId &&
          role.parentOrgId != null &&
          (role.code == 'SUBAUTHREP' || role.code == 'SUBMEMBER')
        ) {
          entityTypeId = ENTITY_MAP.PROGRAM_ORGANIZATION_SUBORGANIZATION.code;
        }
        return _.map(role.programs, (program) => {
          const entityId =
            entityTypeId == ENTITY_MAP.PROGRAM_ORGANIZATION_SUBORGANIZATION.code ||
            (role.parentOrgId && entityTypeId != ENTITY_MAP.PROGRAM_ORGANIZATION.code)
              ? `${role.parentOrgId}_${program.programId}_${selectedOrgId}`
              : `${selectedOrgId}_${program.programId}`;
          return {
            entityId: entityId,
            entityTypeId: entityTypeId,
            roleId: role.roleId.toString(),
          };
        });
      } else {
        return {
          entityId: `${selectedOrgId}`,
          entityTypeId: entityTypeId,
          roleId: role.roleId.toString(),
        };
      }
    } else if (role.programs && role.programs.length) {
      return _.map(role.programs, (program) => {
        const entityId =
          role.entityTypeId == ENTITY_MAP.PROGRAM_ORGANIZATION_SUBORGANIZATION.code ||
          role.parent
            ? `${role.parent}_${program.programId}_${selectedOrgId}`
            : `${selectedOrgId}_${program.programId}`;
        return {
          entityId: entityId,
          entityTypeId:
            role.entityTypeId == ENTITY_MAP.PROGRAM_ORGANIZATION_SUBORGANIZATION.code ||
            role.parent
              ? ENTITY_MAP.PROGRAM_ORGANIZATION_SUBORGANIZATION.code
              : ENTITY_MAP.PROGRAM_ORGANIZATION.code,
          roleId: _.invert(ROLE_MAP)[role.roles],
        };
      });
    } else if (role.roles != '') {
      return {
        entityId: `${selectedOrgId}`,
        entityTypeId: '1',
        roleId: _.invert(ROLE_MAP)[role.roles],
      };
    }
  };

  const originalUser = _.flatMap(_.map(values.originalUser, mapToCorrectFormat));
  const user = _.flatMap(_.map(values.user, mapToCorrectFormat));

  const toAdd = _.differenceWith(user, originalUser, _.isEqual);
  const toDelete = _.differenceWith(originalUser, user, _.isEqual);

  return {
    add: _.filter(toAdd, (r) => r != null),
    delete: _.filter(toDelete, (r) => r != null),
  };
};

export const createEntityOptions = (rolePayload) => {
  return _.filter(
    _.uniqBy(
      _.map(rolePayload, (role) => {
        return {
          text: role.displayName,
          value: role.entityId,
        };
      }),
      'text'
    ),
    (role) => {
      return role.value !== null;
    }
  );
};

export const createRoleOptions = (payload, rolesFromPermissions, subOrgToggle) => {
  let roleMap = {};
  let entity = '';

  _.forEach(payload, (role) => {
    entity = role.entity.displayName;
    _.forEach(role.roles, (obj) => {
      let assignableRoles = selectableRoles(rolesFromPermissions, subOrgToggle);
      _.forEach(assignableRoles, (roleInArray) => {
        if (_.has(roleMap, entity)) {
          roleMap[entity].push({
            text: roleInArray,
            value: roleInArray,
          });
        } else {
          roleMap[entity] = [
            {
              text: roleInArray,
              value: roleInArray,
            },
          ];
        }
      });
    });
  });
  _.forEach(roleMap, (entity, index) => {
    roleMap[index] = _.orderBy(
      _.uniqWith(entity, _.isEqual),
      [(record) => _.toLower(_.get(record, 'text', ''))],
      ['asc']
    );
  });
  return roleMap;
};

const selectableRoles = (roles, subOrgToggle) => {
  let selectableRolesList = [];
  let roleTemp = [];
  const ROLE_TO_ROLES_MAP_KEY =
    subOrgToggle === true ? ROLE_TO_ROLES_MAP_v2 : ROLE_TO_ROLES_MAP;

  if (roles != null) {
    _.each(_.intersection(roles, _.keys(ROLE_TO_ROLES_MAP_KEY)), (roleId) => {
      roleTemp = roleTemp.concat(ROLE_TO_ROLES_MAP_KEY[roleId]);
    });

    _.each(_.uniq(roleTemp), (roleId) => {
      selectableRolesList.push(ROLE_MAP[roleId]);
    });
  }
  return selectableRolesList;
};

export const createRolePermissionsBox = (roles, manageTeamOrgSubOrgToggle) => {
  if (roles != null) {
    _.each(_.intersection(roles, _.keys(ROLE_TO_ROLES_MAP)), (roleId) => {
      roles = roles.concat(ROLE_TO_ROLES_MAP[roleId]);
    });
    const uniqueRoles = _.uniq(roles);
    let items = [];
    const permissionsMapToUse =
      manageTeamOrgSubOrgToggle === true ? PERMISSIONS_MAP_V2 : PERMISSIONS_MAP;

    _.each(uniqueRoles, (roleId) => {
      let item = {};
      item.id = roleId;
      item.name = ROLE_MAP[roleId];
      item.tag = (
        <div key={roleId}>
          <strong>{ROLE_MAP[roleId]}</strong> - {permissionsMapToUse[ROLE_MAP[roleId]]}
        </div>
      );
      items.push(item);
    });

    const sorteditems = _.sortBy(items, 'name');
    const tags = _.map(sorteditems, (record) => {
      return record.tag;
    });

    return (
      <Message
        info
        icon="info blue circle"
        color="blue"
        content={tags}
        header="Role permissions:"
      />
    );
  }
};

export const appendMatchingProgram = (
  assignedPrograms,
  accessiblePrograms,
  currentProgram
) => {
  let matchedProgram = _.find(
    accessiblePrograms,
    (p) => p.programId === currentProgram.programId
  );
  if (matchedProgram && matchedProgram.programName) return matchedProgram.programName;

  matchedProgram = _.find(
    assignedPrograms,
    (p) => p.programId === currentProgram.programId
  );
  if (matchedProgram) return matchedProgram.programName;

  if (currentProgram && currentProgram.programName) return currentProgram.programName;

  {
    //Something went wrong with that user and the program names were not properly loaded
    return 'Unknown Program Name';
  }
};

export const hasNoRestrictedProgram = (accessiblePrograms, programs) => {
  const originalSize = _.size(programs);
  let filteredSize = 0;
  _.each(programs, (prg) => {
    let matchFound = _.find(accessiblePrograms, (p) => p.programId === prg.programId);
    if (!_.isUndefined(matchFound)) filteredSize++;
  });
  return originalSize === filteredSize;
};
